'use client';

import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import { IsomorphicLink } from '@flipster/react/design-utils/isomorphic-link';
import { css } from '@flipster/styled-system/css';
import { center, grid, linkOverlay } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { MainEvent } from '@flipster/utils/segment/events/main';

import { partners } from '@web/app/[locale]/(web)/_partners';

import { maxWStyles } from '../_styles';

const Partners = () => {
  const onClickPartnershipLearnMore = () => {
    segment.track(MainEvent.IntroducePartnershipLearnMoreClick, {
      event_location: 'main_page_view',
    });
  };

  return (
    <div className={css(maxWStyles, { pb: { base: 48, tablet: 96 } })}>
      <h2 className={css({ textStyle: 'Title/M', color: 'content.default.level-5' })}>
        <FormattedMessage id='Common.r251104.Our_partners' />
      </h2>
      <p className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-3', pt: 16 })}>
        <FormattedMessage id='Main.r251104.Proud_collaborate_with_trusted_partners_deliver_trading_experience_desc' />
      </p>
      <ul
        className={grid({
          pt: 32,
          gap: { base: 8, tablet: 16 },
          columns: { base: 2, tablet: 3, smallDesktop: 4 },
          gridAutoRows: { base: 68, tablet: 100 },
        })}
      >
        {partners.slice(0, 8).map((partner) => (
          <li
            key={partner.name}
            className={center({
              pos: 'relative',
              bgColor: 'background.default.level-1',
              rounded: { base: 4, tablet: 8 },
            })}
          >
            {partner.icon}
            {partner.url && <IsomorphicLink href={partner.url} newTab className={linkOverlay()} />}
          </li>
        ))}
      </ul>
      <div className={center({ mt: 40 })}>
        <Button
          href='/about'
          as='a'
          label={<FormattedMessage id='Common.r250401.Learn_more' />}
          size='large'
          css={{ minW: 120 }}
          onClick={onClickPartnershipLearnMore}
        />
      </div>
    </div>
  );
};

export default Partners;
